import { useCallback } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Slider } from '@hivebrite/design-system/Slider';

import type { PartnersSliderUIProps } from 'hb-builder/components/UIComponents/page/block/Partners/PartnersSlider/types';

import SliderCard from './SliderCard';

const SliderUI = ({
  item,
  onClickCallBack,
  onDoubleClickCallBack,
  subdomainNetworkUrl,
  withImageSetter,
}: PartnersSliderUIProps) => {
  const items = item?.children;

  const renderItem = useCallback(
    (childItem) => {
      const { _imageData, logoBackground, openInNewTab, partnerImage } =
        childItem.attributes;
      const { partnerImageAlt, partnerImageUrl } = childItem;

      const props = {
        logoBackground,
        onClickCallBack,
        onDoubleClickCallBack,
        openInNewTab,
        partnerImage: _imageData || partnerImage,
        partnerImageAlt,
        partnerImageUrl,
        subdomainNetworkUrl,
        withImageSetter,
      };

      return <SliderCard item={childItem} {...props} />;
    },
    [
      onClickCallBack,
      onDoubleClickCallBack,
      subdomainNetworkUrl,
      withImageSetter,
    ],
  );

  if (!items) {
    return null;
  }

  return (
    <SliderWrapper dataTestId="partners-slider-ui">
      <Slider
        items={items}
        loading={false}
        renderItemComponent={renderItem}
        renderLoadingItemComponent={() => <div />}
        total={items.length}
      />
    </SliderWrapper>
  );
};

export default SliderUI;

const SliderWrapper = styled(Box).attrs(() => ({
  mb: 6,
  mt: { _: 6, l: 80 },
  width: '100%',
}))`
  .slider-container {
    width: 100%;
  }
`;
